"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _utilities = require("../../utilities");

var _Snippets = _interopRequireDefault(require("./Snippets"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var TagManager = {
  gtm: function gtm(args) {
    var snippets = _Snippets["default"].tags(args);

    var script = function script() {
      var element = document.createElement('script');
      element.innerHTML = snippets.script;
      return element;
    };

    var noScript = function noScript() {
      var element = document.createElement('noscript');
      element.innerHTML = snippets.noScript;
      return element;
    };

    var dataLayer = function dataLayer() {
      var element = document.createElement('script');
      element.innerHTML = snippets.dataLayer;
      return element;
    };

    return {
      noScript: noScript,
      script: script,
      dataLayer: dataLayer
    };
  },
  pushToDataLayer: function pushToDataLayer(data) {
    typeof window.dataLayer !== 'undefined' && window.dataLayer && window.dataLayer.push(data);
  },
  initialize: function initialize(id) {
    // tslint:disable-next-line
    var gtm = this.gtm({
      id: id
    });
    var script = gtm.script();
    var noScript = gtm.noScript();
    var dataLayer = gtm.dataLayer();
    !(0, _utilities.doesScriptExist)(dataLayer) && document.head.appendChild(dataLayer);
    !(0, _utilities.doesScriptExist)(script) && document.head.insertBefore(script, document.head.childNodes[0]);
    !(0, _utilities.doesNoScriptExist)(noScript) && document.body.insertBefore(noScript, document.body.childNodes[0]);
  }
};
var _default = TagManager;
exports["default"] = _default;